module.exports = __webpack_public_path__ + "img/prize-baseliao.4d2a8efb.png";